import { DropdownItem, LookupModelSelectionEvent } from "@mcleod/components";
import { AutogenLayoutSearchLayoutCarrierFuelSurchargePay } from "./autogen/AutogenLayoutSearchLayoutCarrierFuelSurchargePay";
import { Api } from "@mcleod/core";

export class SearchLayoutCarrierFuelSurchargePay extends AutogenLayoutSearchLayoutCarrierFuelSurchargePay {
    async customFuelSurchargeIndexIdOnLookupModelSelection(event: LookupModelSelectionEvent) {
        if (event.hasSelection()) {
            this.textboxCustomFscRegionId.enabled = true;
            Api.post("lme/ar/custom-fuel-region", { fuel_index_id: event.selection?.get("id") }).then((response) => {
                if (response.data[0]?.custom_fuel_region) {
                    this.fillItems(response.data[0]?.custom_fuel_region);
                }
            });
        } else {
            this.textboxCustomFscRegionId.enabled = false;
            this.textboxCustomFscRegionId.selectedItem = null;
            this.mainDataSource.activeRow.set("custom_fsc_region_id", null);
        }
    }

    private fillItems(items: any) {
        const customFuelRegion: any[] = items
        this.textboxCustomFscRegionId.items = customFuelRegion.map((item) => {
            return new DropdownItem(item.dbValue, item.displayValue);
        });
    }

}